import React from 'react';

import InsertConversationSummary from 'components/text_editor/plugins/ai_actions/insert_conversation_summary';

export function ConversationSummary({ conversationId, customerId }) {
  return {
    renderEditor({ onChange }, editor, next) {
      const children = next();
      return (
        <>
          {children}
          <InsertConversationSummary
            conversationId={conversationId}
            customerId={customerId}
            editor={editor}
            onChange={onChange}
          />
        </>
      );
    },
  };
}
